import * as React from "react";
import { navigate } from "gatsby";

interface LinkProps {
  to: string;
  state?: object | null;
  onBeforeLeave?: (resolve: () => void) => void;
  gaClass: string;
}

const Link: React.FC<LinkProps> = (props) => {
  const waitLeave = () => {
    return new Promise((resolve) => {
      const pushResolve = () => {
        resolve(null);
      };
      props.onBeforeLeave(pushResolve);
    });
  };

  const handleBeforeLeave = async () => {
    await waitLeave();
    await navigate(props.to, { state: props.state });
  };

  return (
    <button
      type={"button"}
      onClick={handleBeforeLeave}
      className={props.gaClass}
    >
      {props.children}
    </button>
  );
};

Link.defaultProps = {
  state: null,
  onBeforeLeave: (resolve: () => void) => {
    resolve();
  },
};

export default Link;
